class PromoPopup extends HTMLElement {
  constructor() {
    super();

    const self = this;

    // Não exibe na página de desafio da Shopify
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'newsletter-popup';

    this.classes = {
      bodyClass: 'newsletter-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.displayMode =
      this.dataset.display ||
      this.getAttribute('data-display') ||
      '';

    this.popup = this.querySelector('.popup-container');
    this.teaserButton = this.querySelector('.button-teaser');
    this.closeTeaserIcon =
      this.teaserButton?.querySelector('.teaser-close');

    this.contentContainer = this.querySelector(
      '.popup-newsletter-content-wrapper .newsletter__wrapper'
    );

    this.behavior =
      this.dataset.behavior ||
      this.getAttribute('data-behavior') ||
      '';

    this.disabled =
      this.dataset.disabled ||
      this.getAttribute('data-disabled') ||
      '';

    this.delay =
      this.dataset.delay ||
      this.getAttribute('data-delay') ||
      0;

    this.form = this.querySelector(
      '.popup-newsletter-content-wrapper form'
    );

    /*
     * Botão X.
     */
    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener(
        'click',
        this.onButtonClick.bind(this)
      );
    });

    /*
     * Fecha somente clicando no fundo externo.
     * Cliques dentro do cupom não fecham.
     */
    this.popup?.addEventListener('click', (event) => {
      const clickedOutside =
        event.target === this.popup ||
        event.target.classList.contains(
          'popup-newsletter-overlay'
        );

      if (clickedOutside) {
        this.close();
      }
    });

    this.init();

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const isSelectorSection =
          event.target.querySelector('promo-popup');

        if (isSelectorSection) {
          self.init();
        }
      }
    );

    this.teaserButton?.addEventListener(
      'click',
      this.onClickTeaserButton.bind(this)
    );

    this.closeTeaserIcon?.addEventListener(
      'click',
      this.onHideTeaserButton.bind(this)
    );

    this.closeTeaserIcon?.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === ' ' ||
          event.key === 'Enter'
        ) {
          event.stopPropagation();
          event.preventDefault();
          this.onHideTeaserButton(event);
        }
      }
    );

    if (this.form) {
      this.form.addEventListener(
        'submit',
        this.onFormSubmit.bind(this)
      );
    }
  }

  onFormSubmit(event) {
    event.preventDefault();

    this.setCookie(
      this.cookieName,
      this.dataset.expiry
    );
  }

  onClickTeaserButton() {
    this.openPopup();
  }

  onHideTeaserButton(event) {
    event.preventDefault();
    event.stopPropagation();

    this.toogleTeaserButton('none');
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad =
        this.onSectionLoad.bind(this);

      this.onShopifySectionSelect =
        this.onSectionSelect.bind(this);

      this.onShopifySectionDeselect =
        this.onSectionDeselect.bind(this);

      document.addEventListener(
        'shopify:section:load',
        this.onShopifySectionLoad
      );

      document.addEventListener(
        'shopify:section:select',
        this.onShopifySectionSelect
      );

      document.addEventListener(
        'shopify:section:deselect',
        this.onShopifySectionDeselect
      );
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener(
        'shopify:section:load',
        this.onShopifySectionLoad
      );

      document.removeEventListener(
        'shopify:section:select',
        this.onShopifySectionSelect
      );

      document.removeEventListener(
        'shopify:section:deselect',
        this.onShopifySectionDeselect
      );

      document.body.classList.remove(
        this.classes.bodyClass
      );
    }
  }

  onSectionLoad(event) {
    filterShopifyEvent(
      event,
      this,
      this.open.bind(this)
    );
  }

  onSectionSelect(event) {
    filterShopifyEvent(
      event,
      this,
      this.open.bind(this)
    );
  }

  onSectionDeselect(event) {
    filterShopifyEvent(
      event,
      this,
      this.close.bind(this)
    );
  }

  init() {
    if (
      (Shopify && Shopify.designMode) ||
      this.disabled === 'true'
    ) {
      return;
    }

    if (
      this.behavior === 'before_and_after' ||
      (
        this.behavior === 'before' &&
        !this.getCookie(this.cookieName)
      )
    ) {
      this.toogleTeaserButton('flex');
    }

    if (
      this.dataset.testMode === 'true' ||
      (
        !this.getCookie(this.cookieName) &&
        this.behavior === 'after'
      )
    ) {
      this.open();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (
      this.popup.classList.contains(
        this.classes.activeClass
      )
    ) {
      this.close();
    } else {
      this.openPopup();
    }
  }

  toogleTeaserButton(display) {
    if (!this.teaserButton) {
      return;
    }

    this.teaserButton.style.display = display;
  }

  openPopup() {
    if (!this.popup) {
      return;
    }

    this.popup.classList.remove(
      this.classes.closingClass
    );

    this.popup.classList.add(
      this.classes.activeClass
    );

    document.body.classList.add(
      'overflow-hidden'
    );

    document.documentElement.classList.add(
      'overflow-hidden'
    );

    if (this.teaserButton) {
      this.teaserButton.classList.remove('hidden');
    }

    if (this.behavior === 'before_and_after') {
      this.toogleTeaserButton('flex');
    } else {
      this.toogleTeaserButton('none');
    }

    /*
     * Mantém a animação antiga somente no desktop.
     * No celular, o CSS personalizado controla o surgimento.
     */
    if (
      window.matchMedia('(min-width: 750px)').matches
    ) {
      this.popup.classList.add(
        this.classes.showImage
      );
    } else {
      this.popup.classList.remove(
        this.classes.showImage
      );
    }

    if (
      this.popup.dataset.position === 'center'
    ) {
      document.body.classList.add(
        this.classes.bodyClass
      );
    }

    this.contentContainer = this.querySelector(
      '.popup-newsletter-content-wrapper'
    );

    this.style.setProperty(
      '--min-image-height',
      `${this.contentContainer?.clientHeight || 0}px`
    );
  }

  open() {
    window.setTimeout(() => {
      this.openPopup();
    }, parseInt(this.delay, 10) * 1000);
  }

  close() {
    if (
      !this.popup ||
      !this.popup.classList.contains(
        this.classes.activeClass
      ) ||
      this.popup.classList.contains(
        this.classes.closingClass
      )
    ) {
      return;
    }

    this.popup.classList.add(
      this.classes.closingClass
    );

    if (
      this.behavior === 'after' ||
      this.behavior === 'before_and_after'
    ) {
      this.toogleTeaserButton('flex');
    } else {
      this.toogleTeaserButton('none');
    }

    window.setTimeout(() => {
      this.popup.classList.remove(
        this.classes.activeClass
      );

      this.popup.classList.remove(
        this.classes.closingClass
      );

      this.popup.classList.remove(
        this.classes.showImage
      );

      document.body.classList.remove(
        'overflow-hidden'
      );

      document.documentElement.classList.remove(
        'overflow-hidden'
      );

      if (
        this.popup.dataset.position === 'center'
      ) {
        document.body.classList.remove(
          this.classes.bodyClass
        );
      }
    }, 300);

    if (
      this.dataset.testMode === 'true' ||
      this.displayMode === 'test'
    ) {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(
      this.cookieName,
      this.dataset.expiry
    );
  }

  getCookie(name) {
    const match = document.cookie.match(
      `(^|;)\\s*${name}\\s*=\\s*([^;]+)`
    );

    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie =
      `${name}=true; max-age=${
        expiry * 24 * 60 * 60
      }; path=/`;
  }

  removeCookie(name) {
    document.cookie =
      `${name}=; max-age=0; path=/`;
  }
}

if (!customElements.get('promo-popup')) {
  customElements.define(
    'promo-popup',
    PromoPopup
  );
}

function filterShopifyEvent(
  event,
  domElement,
  callback
) {
  let executeCallback = false;

  if (event.type.includes('shopify:section')) {
    if (
      domElement.hasAttribute('data-section-id') &&
      domElement.getAttribute('data-section-id') ===
        event.detail.sectionId
    ) {
      executeCallback = true;
    }
  } else if (
    event.type.includes('shopify:block') &&
    event.target === domElement
  ) {
    executeCallback = true;
  }

  if (executeCallback) {
    callback(event);
  }
}